import { Tooltip } from '@mui/material'
import { ReactNode } from 'react'
import { CountBadge } from './CountBadge'

export type OverflowCountBadgeProps = {
  count: number
  hint?: ReactNode
}

export const OverflowCountBadge = ({ count, hint = '' }: OverflowCountBadgeProps) => {
  if (count <= 0) return null

  return (
    <Tooltip title={hint}>
      <CountBadge count={`+${count}`} color="neutral" />
    </Tooltip>
  )
}
